































































































































































import { DataProxy } from 'apollo-cache';
import * as R from 'ramda';
import Vue from 'vue';

import { Client, ClientProduct } from '@/core/entity';
import { getClientQL, productFragment } from './graphql';

import ProductForm from './Form.vue';

export default Vue.extend({
  components: {
    'form-product': ProductForm,
  },
  apollo: {
    client: {
      query: getClientQL,
      variables() {
        return {
          clientId: this.clientId,
        };
      },
    },
  },

  data() {
    const productId = this.$route.params.product_id;

    return {
      client: undefined as Client | undefined,
      isDrawerVisible: productId ? true : false,
      loading: false,
    };
  },

  computed: {
    cardTitle(): string {
      if (this.client) {
        return `${this.client.name}'s Product List`;
      }
      return '';
    },

    clientId(): string {
      return this.$route.params.client_id;
    },

    filter(): string {
      const routeName: string = this.$route.name!;

      return routeName.indexOf('unassigned') !== -1 ? 'unassigned' : 'assigned';
    },

    productId(): string {
      return this.$route.params.product_id;
    },

    product(): ClientProduct | undefined {
      if (this.client && this.client.products) {
        return R.find(R.propEq('id', this.productId), this.client!.products!);
      }
      return undefined;
    },

    products(): ClientProduct[] {
      return this.filter === 'assigned'
        ? this.productsAssigned
        : this.productsUnassigned;
    },

    productsAssigned(): ClientProduct[] {
      if (this.client) {
        return R.filter((p) => !!p.intrackProduct, this.client
          .products as ClientProduct[]);
      }
      return [];
    },

    productsUnassigned(): ClientProduct[] {
      if (this.client) {
        return R.filter((p) => !p.intrackProduct, this.client
          .products as ClientProduct[]);
      }
      return [];
    },
  },

  watch: {
    productId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    hideDrawer() {
      this.isDrawerVisible = false;
      this.$router.back();
    },

    handleMenuClick(e: any) {
      this.$router.push({
        name: `client.product-${e.key}`,
        params: { client_id: this.clientId },
      });
    },

    handleSubmit(val: any) {
      const { clientId } = this;
      const clientProduct = val.client;
      const intrackProduct = val.intrack;

      this.$coreApp.clientProduct.mapClientProduct(
        {
          clientId,
          clientProductId: clientProduct,
          intrackProductId: intrackProduct,
        },
        this.presenter('Product mapped.', 'Unable to map product:'),
        { name: 'ListClientProductPageClientProduct', query: productFragment },
        this.updater,
      );
    },

    presenter(success: string, failure: string) {
      return (
        err: Error | null,
        result: ClientProduct | null,
        loading: boolean,
      ) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          this.$router.back();
        }
      };
    },

    updater(store: DataProxy, res: { data: { mapProduct?: ClientProduct } }) {
      const clientProduct = res.data.mapProduct as ClientProduct;

      const data: { client: Client } | null = store.readQuery({
        query: getClientQL,
        variables: {
          clientId: this.clientId,
        },
      });

      if (!data) {
        // tslint:disable-next-line no-console
        console.error('data is null or undefined');
        return;
      }

      if (!data.client) {
        // tslint:disable-next-line no-console
        console.error('data.client is null or undefined');
        return;
      }

      if (!data.client.products) {
        // tslint:disable-next-line no-console
        console.error('data.client.products is null or undefined');
        return;
      }

      const idx = R.findIndex(R.propEq('id', `${this.clientId}:${clientProduct.id}`))(
        data.client.products,
      );
      if (idx !== -1) {
        const previous = data.client.products[idx];
        data.client.products = R.update(
          idx,
          {
            ...previous,
            ...clientProduct,
          },
          data.client.products,
        );
        store.writeQuery({
          query: getClientQL,
          variables: {
            clientId: this.clientId,
          },
          data,
        });
      }
    },
  },
});
